import { ACL_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type { SpaceAccess } from '@eggplant/types'

interface Props {
  spaceId: string
  onSuccess?: (response: SpaceAccess) => void
  onError?: () => void
}

const PollGetSpaceAccessControlRequest = ({
  spaceId,
  onSuccess,
  onError
}: Props) => {
  const url = `${ACL_SERVICE}/acls/space/${spaceId}/current_user`

  return (
    <AuthenticatedPolling<SpaceAccess>
      intervalMs={30000}
      isPolling
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollGetSpaceAccessControlRequest
